import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Box } from '@/components/Box';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import type {
  AllSelectedProducts,
  Product,
} from '@/hooks/useAllSelectedProductsState';
import type { StrapAddToBagTool } from '@/hooks/useBucklesAndTools';
import type { SetState } from '@/lib/types';
import { commonMessages } from '@/messages/common';
import { ProductItem } from '@/views/ShoppingBagView/components/ShoppingBagStrapDrawer/components';

import * as M from '../../messages';
import * as S from './NiceToHaveSection.styles';

export interface NiceToHaveSectionProps {
  allProduct?: AllSelectedProducts | null;
  niceToHaveProducts: StrapAddToBagTool[];
  setAllSelectedProducts: SetState<AllSelectedProducts>;
}

export const NiceToHaveSection = ({
  allProduct,
  niceToHaveProducts,
  setAllSelectedProducts,
}: NiceToHaveSectionProps) => {
  const { formatMessage } = useIntl();
  const [selectedSku, setSelectedSku] = useState<null | string>(null);
  useEffect(() => {
    if (allProduct?.products.length) {
      const seletedSku = allProduct?.products.find(
        (item: Product) => item.productTypeSlug === 'tool',
      );
      setSelectedSku(seletedSku?.sku ?? null);
    }
  }, [allProduct]);
  return (
    <S.Wrapper data-testid='NiceToHaveSectionWrapper'>
      <SectionHeader
        data-testid='NiceToHaveSectionHeader'
        disableGutters
        numberOfColoredWords={0}
        sizeDesktop={24}
        sizeMobile={20}
        text={formatMessage(commonMessages.niceToHave)}
        textAlign='center'
      />
      <Box marginBottom={1} />
      <Typography
        data-testid='NiceToHaveSectionTypography'
        marginBottom={2}
        textAlign='center'
      >
        {M.NiceToHaveTopDescription}
      </Typography>
      {niceToHaveProducts.map((item, index) => {
        return (
          <ProductItem
            key={item.sku}
            data={item}
            data-testid={`NiceToHaveSectionProductRow-${index}`}
            isClickable
            productType='tool'
            selectedSku={selectedSku}
            setAllSelectedProducts={setAllSelectedProducts}
            setSelectedSku={setSelectedSku}
          />
        );
      })}
    </S.Wrapper>
  );
};
